import React, { useRef } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { ThreeDots } from 'react-loader-spinner';
import { Toast } from 'primereact/toast';

import { googleCallbackForSendMail } from "../services/api/auth";
import { raiseToast } from "../services/redux/reducers/toast/toast";
import { updateUserGoogleVerification } from "../services/redux/reducers/user/user";

const GoogleSendMailRedirect = () => {
    const toast = useRef(null)

    const dispatch = useDispatch()

    const sleep = async (milliseconds) => {
        await new Promise(resolve => {
            return setTimeout(resolve, milliseconds)
        })
    }
    
    const getToken = async () => {
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')

        if (code) {
            const response = await googleCallbackForSendMail({ code })
            console.log('rs', response)
            if(response.failure) return dispatch(raiseToast({severity:'error', summary: 'User Google Verification', detail: response.data.error, life: 3000}))
            else{  //Not working
                console.log('else exe')
                dispatch(raiseToast({severity:'success', detail: "Google verification is successful. Please refresh the page once!", life: 3000}))
                await sleep(3000)
                // toast.current.show({ severity: 'success', summary: 'User Google Verification', detail: 'Verification is successful', life: 3000 })
                dispatch(updateUserGoogleVerification(true))   
            }
            //can use redux to update the whole page. And we can use to mark check in edit user page.
            window.close()
        }
    }

    useEffect(() => {
        getToken()
    }, [])

    return(
        <div className="flex flex-row justify-content-center align-items-center h-screen">
            <Toast ref={toast} />
            <ThreeDots height="70" width="70" radius="7"color="#00baac" ariaLabel="three-dots-loading" visible={true} /> 
        </div>
    )
}

export default GoogleSendMailRedirect